<form>
  <h1 mat-dialog-title class="air-theme">

    @if (!data.isNew && data.essay.fromProtocol) {
      <mat-checkbox matTooltip="{{ 'button.enable' | translate }}" [checked]="data.essay.active"
        (change)="data.essay.active = $event.checked">
      </mat-checkbox>
    }

    {{ getEssayName(data.essay.idEssayType) | translate }}

  </h1>
  <div mat-dialog-content class="air-theme">

    @if (!data.essay.active) {
      <div>
        <mat-toolbar color="secondary">
          {{ 'executionEdit.sensorConfig.evaluateReason.label' | translate }}
        </mat-toolbar>
        <mat-label>{{ 'executionEdit.sensorConfig.evaluateReason.label' | translate }}</mat-label>
        <textarea matInput rows="5" name="reasonActive" required style="resize: none;"
        [(ngModel)]="data.essay.reasonActive"></textarea>
        <div fxLayout="column" class="flexwrap">
          <div fxFlex>
            <mat-checkbox name="showDiffInDeviations" [(ngModel)]="data.essay.showDiffInDeviations">
              {{ 'executionEdit.sensorConfig.showDiffInDeviations.label' | translate }}
            </mat-checkbox>
          </div>
          <div fxFlex>
            <mat-checkbox name="showDiffInObservations" [(ngModel)]="data.essay.showDiffInObservations">
              {{ 'executionEdit.sensorConfig.showDiffInObservations.label' | translate }}
            </mat-checkbox>
          </div>
        </div>
      </div>
    }

    @if (data.essay.active) {
      <div fxLayout="row" class="flexwrap">
        <div fxFlex="100">
          <mat-checkbox (change)="setForceAccording($event)" [checked]="data.essay.forceAccording"
            [disabled]="!enableEditEssay()">
            {{ 'executionEdit.dialog.essay.forceAccording' | translate }}
          </mat-checkbox>
        </div>
        @if (units?.length !== 0) {
          <div fxFlex="100">
            <mat-form-field class="campoFormulario">
              <mat-label>{{ 'calibrateEquipmentEdit.calibrationData.unit.label' | translate }}</mat-label>
              <mat-select name="unit" [(ngModel)]="data.essay.idUnit" required [disabled]="units.length < 2">
                @for (item of units; track item) {
                  <mat-option [value]="item.id">
                    {{item.unit}}
                  </mat-option>
                }
              </mat-select>
              <mat-error>
                {{ 'calibrateEquipmentEdit.calibrationData.unit.error' | translate }}
              </mat-error>
            </mat-form-field>
          </div>
        }
        <mat-toolbar color="secondary">
          {{ 'protocolEdit.essays.criteria.label' | translate }}
          @if (!showMicrobiological) {
            <button mat-icon-button color="accent" (click)="openNewCriteria()"
              matTooltip="{{ 'executionEdit.dialog.essay.add.criteria' | translate }}"
              [disabled]="!enableEditCriteria()">
              <mat-icon class="icon-display-plus">add</mat-icon>
            </button>
          }
        </mat-toolbar>
        <!-- Smoke Electric Paralelism-->
        @if (showAccording) {
          <div fxLayout="row" class="flexwrap">
            <div fxFlex="100" fxFlex.lt-md="100%">
              <span> {{ 'executionEdit.dialog.essay.result' | translate }} </span>
              <mat-radio-group [(ngModel)]="data.essay.according" name="essayAccording">
                <div fxLayout="row" fxFlex="100%">
                  <mat-radio-button [value]="true" [disabled]="!enableEditEssay()">
                    {{'executionEdit.dialog.essay.according' | translate}}
                  </mat-radio-button>
                  <mat-radio-button [value]="false" [disabled]="!enableEditEssay()">
                    {{'executionEdit.dialog.essay.notAccording' | translate}}
                  </mat-radio-button>
                </div>
              </mat-radio-group>
            </div>
          </div>
        }

        <!-- Saturation -->
        @if (showSaturation) {
          <div fxLayout="row" class="flexwrap">
            <div fxLayout="row" fxFlex="100%">
              <div fxFlex="40" fxFlex.lt-md="100%">
                <span> {{ 'executionEdit.dialog.essay.result' | translate }} </span>
                <mat-radio-group [(ngModel)]="data.essay.according" name="essayAccording"
                  [disabled]="!enableEditEssay()">
                  <div fxLayout="row" fxFlex="100%">
                    <mat-radio-button [value]="true"> {{'executionEdit.dialog.essay.according' | translate}}
                    </mat-radio-button>
                    <mat-radio-button [value]="false">
                      {{'executionEdit.dialog.essay.notAccording' | translate}}
                    </mat-radio-button>
                  </div>
                </mat-radio-group>
              </div>
            </div>
            <div fxFlex>
              @for (filter of activeCarbonFilters; track filter; let indexValue = $index) {
                <div fxLayout="row">
                  <div fxLayout="row" fxFlex="100%">
                    {{getIndexFilterSatu(filter)+1}}. {{ showFilterNameSatu(filter)}}
                    {{getSizeFilterSatu(filter)}}
                    <button mat-icon-button (click)="editFilterActiveCoal(filter)"
                      matTooltip="{{ 'button.edit' | translate }}">
                      <mat-icon>mode_edit</mat-icon>
                    </button>
                  </div>
                </div>
              }
            </div>
          </div>
        }
        <!-- Each criteria by essay -->
        @for (criteria of getCriteriaByEssay(); track criteria; let indexCriteria = $index) {
          <div fxLayout="row" fxFlex="100%" class="flexwrap"
            >
            <div fxLayout="row" fxFlex="100%">
              <span style="margin-top: 0.75em">
                {{ 'protocolEdit.dialog.essay.criteria.cols.criteria' | translate }}:
                <span
                [innerHtml]="((renFlowAndRate || showAirSpeedBioII || showHeavyCabin) ? getCriteriaOfEssay() : getCriteria(criteria)) | safe: 'html'"></span>
              </span>
              <button mat-icon-button color="accent" (click)="editCriteria(indexCriteria)"
                [disabled]="!enableEditCriteria()" matTooltip="{{ 'button.edit' | translate }}">
                <mat-icon class="icon-display">mode_edit</mat-icon>
              </button>
              @if (data.essay.criterias?.length > 1 && !showMicrobiological) {
                <button mat-icon-button color="accent" (click)="deleteCriteria(indexCriteria)"
                  [disabled]="!enableEditCriteria()">
                  <mat-icon class="icon-display">delete</mat-icon>
                </button>
              }
              @if (!showParticleCount && !showMicrobiological && false) {
                <button mat-icon-button color="accent" (click)="newValue(indexCriteria)"
                  [disabled]="!enableEditEssay()">
                  <mat-icon class="icon-display-plus">add</mat-icon>
                </button>
              }
            </div>
            <!-- Microbiologic -->
            @if (showMicrobiological) {
              <div fxLayout="column" style="width: 100%;">
                @for (value of getValuesOfCriteria(criteria); track value; let indexValue = $index) {
                  <div fxFlex fxLayout="row" style="width: 100%;"
                    >
                    <div fxFlex fxLayout="row" style="width: 100%;">
                      <div fxFlex="10" fxFlex.lt-md="100%" style="padding-top: 1em;">
                        <span> Localización {{ indexValue + 1 }} </span>
                      </div>
                      <div fxFlex="20" fxFlex.lt-md="100%">
                        <mat-form-field>
                          <mat-label>{{'executionEdit.dialog.essay.data.samplingDate' | translate }}</mat-label>
                          <input matInput [matDatepicker]="samplingDate" [value]="getDateFromData(value, 0)" required
                            (dateChange)="saveDate(value, 0, $event)" (blur)="saveDate(value, 0, $event)">
                          <mat-datepicker-toggle matSuffix [for]="samplingDate"></mat-datepicker-toggle>
                          <mat-datepicker #samplingDate >
                          </mat-datepicker>
                        </mat-form-field>
                      </div>
                      @if (showMicrobiologicalEnviroment) {
                        <div fxFlex="1"></div>
                        <div fxFlex="16" fxFlex.lt-md="100%">
                          <mat-form-field>
                            <mat-label>
                              {{(data.compressedGas == null? 'executionEdit.dialog.essay.data.ambient'
                              : 'executionEdit.dialog.essay.data.compressedGas') | translate
                              }}
                            </mat-label>
                            <input matInput [ngModel]="getValueFromData(value, 1)"
                              (ngModelChange)="saveData(value, 1, $event)" required
                              [disabled]="!hasMicrobiologicalAmbient()"
                              name="ambient{{indexCriteria}}{{indexValue}}"
                              [ngModelOptions]="{standalone: true}">
                          </mat-form-field>
                        </div>
                      }
                      @if (showMicrobiologicalSurface) {
                        <div fxFlex="1"></div>
                        <div fxFlex="16" fxFlex.lt-md="100%">
                          <mat-form-field>
                            <mat-label>{{(data.compressedGas == null ? 'executionEdit.dialog.essay.data.surface' : 'executionEdit.dialog.essay.data.compressedGas') | translate}}</mat-label>
                            <input matInput [ngModel]="getValueFromData(value, 1)"
                              (ngModelChange)="saveData(value, 1, $event)" required
                              [disabled]="!hasMicrobiologicalSurface()"
                              name="surface{{indexCriteria}}{{indexValue}}"
                              [ngModelOptions]="{standalone: true}">
                          </mat-form-field>
                        </div>
                      }

                      @if (showMicrobiologicalSedimentation) {
                        <div fxFlex="1"></div>
                        <div fxFlex="16" fxFlex.lt-md="100%">
                          <mat-form-field>
                            <mat-label>{{(data.compressedGas == null ? 'executionEdit.dialog.essay.data.sedimentation' : 'executionEdit.dialog.essay.data.compressedGas') | translate}}</mat-label>
                            <input matInput [ngModel]="getValueFromData(value, 1)"
                              (ngModelChange)="saveData(value, 1, $event)"
                              [disabled]="!hasMicrobiologicalSedimentation()" required
                              name="sedimentation{{indexCriteria}}{{indexValue}}"
                              [ngModelOptions]="{standalone: true}">
                          </mat-form-field>
                        </div>
                      }

                      <div fxFlex="15" fxFlex.lt-md="100%">
                        <mat-form-field>
                          <mat-label>{{'executionEdit.dialog.essay.mouldsYeasts.field' | translate}}</mat-label>
                          <input matInput [ngModel]="getValueFromData(value, 2)"
                            (ngModelChange)="saveData(value, 2, $event)"
                            [disabled]="!enableEditEssay()"
                            name="result{{indexCriteria}}{{indexValue}}"
                            [ngModelOptions]="{standalone: true}">
                        </mat-form-field>
                      </div>
                      <div fxFlex="1"></div>
                      <div fxFlex="15" fxFlex.lt-md="100%">
                        <mat-form-field>
                          <mat-label>{{'executionEdit.dialog.essay.aerobic.field' | translate}}</mat-label>
                          <input matInput [ngModel]="getValueFromData(value, 4)"
                            (ngModelChange)="saveData(value, 4, $event)"
                            [disabled]="!enableEditEssay()"
                            name="result{{indexCriteria}}{{indexValue}}"
                            [ngModelOptions]="{standalone: true}">
                        </mat-form-field>
                      </div>
                      <div fxFlex="30" fxFlex.lt-md="100%">
                        <mat-radio-group [ngModel]="getValueFromData(value, 3)" 
                          (ngModelChange)="saveData(value, 3, $event)"  
                          name="according{{indexCriteria}}{{indexValue}}"
                          [disabled]="!enableEditEssay() || disabledAccordingMicro(value)">
                          <div fxLayout="row" fxFlex="100%">
                            <mat-radio-button [value]="'true'">
                              {{'executionEdit.dialog.essay.according' | translate}}
                            </mat-radio-button>
                            <mat-radio-button [value]="'false'">
                              {{'executionEdit.dialog.essay.notAccording' | translate}}
                            </mat-radio-button>
                          </div>
                        </mat-radio-group>
                      </div>
                    </div>
                  </div>
                }
                <div fxFlex fxLayout="row" style="width: 100%;">
                  <div fxFlex fxLayout="row" class="flexwrap">
                    <div fxFlex="30" fxFlex.lt-md="100%">
                      <span> {{ 'executionEdit.dialog.essay.result' | translate }} </span>
                      <mat-radio-group [(ngModel)]="data.essay.according" name="essayAccording"
                        [disabled]="true">
                        <div fxLayout="row" fxFlex="100%">
                          <mat-radio-button [value]="true">
                            {{'executionEdit.dialog.essay.according' | translate}}
                          </mat-radio-button>
                          <mat-radio-button [value]="false">
                            {{'executionEdit.dialog.essay.notAccording' | translate}}
                          </mat-radio-button>
                        </div>
                      </mat-radio-group>
                    </div>
                    <div fxFlex="10" fxFlex.lt-md="100%">
                      <button mat-icon-button (click)="uploadCertificateInput.click()" color="accent"
                        matTooltip="{{ 'button.upload-certificate' | translate }}"
                        [disabled]="!enableEditEssay()">
                        <mat-icon>cloud_upload</mat-icon>
                      </button>
                      <input accept="application/pdf" hidden type="file" (change)="uploadCertificate($event)"
                        #uploadCertificateInput>
                      @if (data.essay.idCertificate != null) {
                        <button mat-icon-button color="accent" (click)="downloadCertificate()"
                          matTooltip="{{ 'button.download' | translate }}">
                          <mat-icon>cloud_download</mat-icon>
                        </button>
                      }
                    </div>
                  </div>
                </div>
              </div>
            }
            <!-- Induction -->
            @if (showIntroduction) {
              <div fxLayout="row" class="flexwrap">
                <div fxFlex="40" fxFlex.lt-md="100%">
                  <span> {{ 'executionEdit.dialog.essay.result' | translate }} </span>
                  <mat-radio-group [(ngModel)]="data.essay.according" name="essayAccording"
                    [disabled]="!enableEditEssay()">
                    <div fxLayout="row" fxFlex="100%">
                      <mat-radio-button [value]="true"> {{'executionEdit.dialog.essay.according' | translate}}
                      </mat-radio-button>
                      <mat-radio-button [value]="false">
                        {{'executionEdit.dialog.essay.notAccording' | translate}}
                      </mat-radio-button>
                    </div>
                  </mat-radio-group>
                </div>
              </div>
            }
            <!-- Noise light wasteOfLoad(eq) Def Pressure -->
            @if (criteriaSimple) {
              <div fxFlex>
                @for (value of getValuesOfCriteria(criteria); track value; let indexValue = $index) {
                  <div fxLayout="row">
                    <div fxFlex="30">
                      <mat-form-field class="campoFormulario">
                        <mat-label>{{ 'executionEdit.dialog.essay.data.field' | translate }}</mat-label>
                        <input matInput
                          [(ngModel)]="value.value" [errorStateMatcher]="matcher" type="number"
                          [ngModelOptions]="{standalone: true}" [disabled]="!enableEditEssay()">
                        <mat-error>
                          {{ 'executionEdit.dialog.essay.data.field.error' | translate }}
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div fxFlex="10px">
                      @if (showDeleteValue(criteria)) {
                        <button mat-icon-button color="accent" (click)="deleteValue(indexCriteria, indexValue)"
                          [disabled]="!enableEditEssay()">
                          <mat-icon>delete</mat-icon>
                        </button>
                      }
                    </div>
                  </div>
                }
              </div>
            }
            <!-- WasteOfLoad(room)-->
            @if (wasteOfLoadRoom) {
              <div fxFlex>
                @for (value of getValuesOfCriteria(criteria); track value; let indexValue = $index) {
                  <div fxLayout="row">
                    <div fxFlex="30">
                      {{getIndexFilter(value.uuidFilter)+1}}. {{ showFilterName(value.uuidFilter) | translate }} {{showFilterIdentifier(value.uuidFilter)}}
                      {{getSizeFilter(value.uuidFilter)}}
                      <button mat-icon-button (click)="editFilterByUUID(value.uuidFilter)"
                        matTooltip="{{ 'button.edit' | translate }}">
                        <mat-icon>mode_edit</mat-icon>
                      </button>
                    </div>
                    <div fxFlex="30">
                      <mat-form-field class="campoFormulario">
                        <mat-labe>{{ 'executionEdit.dialog.essay.data.field' | translate }}</mat-labe>
                        <input matInput
                          [(ngModel)]="value.value" [errorStateMatcher]="matcher" type="number"
                          [ngModelOptions]="{standalone: true}" [disabled]="!enableEditEssay()">
                        <mat-error>
                          {{ 'executionEdit.dialog.essay.data.field.error' | translate }}
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div fxFlex="10px">
                      @if (showDeleteValue(criteria)) {
                        <button mat-icon-button color="accent" (click)="deleteValue(indexCriteria, indexValue)"
                          [disabled]="!enableEditEssay()">
                          <mat-icon>delete</mat-icon>
                        </button>
                      }
                    </div>
                  </div>
                }
              </div>
            }
            <!-- Temperature humidity-->
            @if (showLocations) {
              <div fxFlex>
                @for (location of getValuesOfCriteria(criteria); track location; let indexLocation = $index) {
                  <div fxLayout="row"
                    >
                    <div fxFlex="10" style="margin-top: 1.5em;">
                      {{ 'executionEdit.dialog.essay.data.location' | translate: {index : indexLocation + 1} }}
                    </div>
                    @for (valueInput of location.data; track trackByIndex(indexValueInput, valueInput); let indexValueInput = $index) {
                      <div fxFlex="9em">
                        <mat-form-field class="campoFormulario">
                          <input matInput type="number" required [value]="valueInput.value"
                            (blur)="setData(location, indexValueInput, $event.target.value)"
                            name="valueInputValue{{indexCriteria}}{{indexLocation}}{{indexValueInput}}"
                            [disabled]="!enableEditEssay()">
                          <mat-error>
                            {{ 'executionEdit.dialog.essay.data.field.error' | translate }}
                          </mat-error>
                          @if (enableEditEssay()) {
                            <button matSuffix mat-icon-button class="btn-close-location"
                              (click)="deleteDataLocation(indexCriteria, indexLocation, indexValueInput)">
                              <mat-icon>close</mat-icon>
                            </button>
                          }
                        </mat-form-field>
                      </div>
                    }
                    <div fxFlex="4em">
                      <mat-form-field class="campoFormulario">
                        <mat-label>
                          {{'executionEdit.dialog.essay.data.average' | translate}}
                        </mat-label>
                        <input matInput disabled [value]="showAverageSpeed(location)">
                      </mat-form-field>
                    </div>
                    <div fxFlex="4">
                      <button mat-icon-button color="accent" (click)="addDataValue(indexCriteria, indexLocation)"
                        [disabled]="!enableEditEssay()">
                        <mat-icon class="icon-display-plus">add</mat-icon>
                      </button>
                    </div>
                    <div fxFlex="4">
                      @if (showDeleteValue(criteria)) {
                        <button mat-icon-button color="accent" (click)="deleteValue(indexCriteria, indexLocation)"
                          [disabled]="!enableEditEssay()">
                          <mat-icon class="icon-display">delete</mat-icon>
                        </button>
                      }
                    </div>
                  </div>
                }
              </div>
            }
            <!-- FilterHepa-->
            @if (showFilterHepa) {
              <div fxFlex>
                @for (value of getValuesOfCriteria(criteria); track value; let indexValue = $index) {
                  <div fxLayout="row">
                    <div fxFlex="30">
                      {{getIndexFilter(value.uuidFilter)+1}}. {{ showFilterName(value.uuidFilter) | translate }} {{showFilterIdentifier(value.uuidFilter)}}
                      {{getSizeFilter(value.uuidFilter)}}
                      <button mat-icon-button (click)="editFilterByUUID(value.uuidFilter)"
                        matTooltip="{{ 'button.edit' | translate }}">
                        <mat-icon>mode_edit</mat-icon>
                      </button>
                    </div>
                    <div fxFlex="30">
                      <mat-form-field class="campoFormulario">
                        <mat-label>{{ 'executionEdit.dialog.essay.data.field' | translate }}</mat-label>
                        <input matInput
                          [(ngModel)]="value.value" [errorStateMatcher]="matcher" type="number"
                          [ngModelOptions]="{standalone: true}" [disabled]="!enableEditEssay()">
                        <mat-error>
                          {{ 'executionEdit.dialog.essay.data.field.error' | translate }}
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div fxFlex="15">
                      <mat-checkbox (change)="setAerosol($event, value)" [checked]="value.aerosol"
                        style="padding-top: 1em;" [disabled]="!enableEditEssay()">
                        Aportar aerosol
                      </mat-checkbox>
                    </div>
                    <div fxFlex="15">
                      <mat-form-field class="campoFormulario">
                        <input matInput [disabled]="!value.aerosol" [(ngModel)]="value.reference"
                          [ngModelOptions]="{standalone: true}">
                        <mat-error>
                          {{ 'executionEdit.dialog.essay.data.field.error' | translate }}
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div fxFlex="10px">
                      @if (showDeleteValue(criteria)) {
                        <button mat-icon-button color="accent" (click)="deleteValue(indexCriteria, indexValue)"
                          [disabled]="!enableEditEssay()">
                          <mat-icon>delete</mat-icon>
                        </button>
                      }
                    </div>
                  </div>
                }
              </div>
            }
            <!-- Contaje de partículas -->
            @if (showParticleCount) {
              @if (online) {
                <div fxFlex="100" fxLayout="column">
                    <div fxLayout="row" class="flexwrap">
                      <mat-toolbar color="secondary">
                        {{ 'executionEdit.dialog.essays.zeroCount.label' | translate }}
                        <mat-checkbox (change)="onChangeZeroCountCheck($event)" [checked]="data.essay.zeroCount"
                          [disabled]="!enableEditEssay()">
                        </mat-checkbox>
                      </mat-toolbar>
                    </div>
                    @if (data.essay.zeroCount) {
                      <div fxFlex>
                        <button mat-icon-button color="accent" (click)="josetizeZeroParticles()"
                          matTooltip="{{ 'button.read-josetizer' | translate }}" [disabled]="!enableEditCriteria()">
                          <mat-icon>published_with_changes</mat-icon>
                        </button>
                        <button mat-icon-button color="accent" (click)="uploadExcelParticleZeroCountInput.click()"
                          matTooltip="{{ 'button.upload-excel' | translate }}" [disabled]="!enableEditCriteria()">
                          <mat-icon>cloud_upload</mat-icon>
                        </button>
                        <input accept=".xlsx, .xls, .csv" hidden type="file" (change)="uploadExcelParticleZeroCount($event)"
                          #uploadExcelParticleZeroCountInput>
                        @if (data.essay?.idExcelZeroCount != null) {
                          <button mat-icon-button color="accent" (click)="downloadExcelParticleZeroCount()"
                            matTooltip="{{ 'button.download-excel' | translate }}">
                            <mat-icon>cloud_download</mat-icon>
                          </button>
                        }
                        <button mat-icon-button color="accent" (click)="downloadZeroJosetizer()"
                          matTooltip="{{ 'button.download-josetizer' | translate }}" [disabled]="!enableEditCriteria()">
                          <mat-icon>add_task</mat-icon>
                        </button>
                        <table #valuesParticlesZero mat-table matSort [dataSource]="data.essay.valuesZeroParticles">
                          <!-- date Column -->
                          <ng-container matColumnDef="date">
                            <th mat-header-cell *matHeaderCellDef>
                              {{ 'executionEdit.dialog.essay.valuesParticles.cols.date' | translate }}
                            </th>
                            <td mat-cell *matCellDef="let item"> {{ item.date | fixDateTime }} </td>
                          </ng-container>
                          <!-- location Column -->
                          <ng-container matColumnDef="location">
                            <th mat-header-cell *matHeaderCellDef>
                              {{ 'executionEdit.dialog.essay.valuesParticles.cols.location' | translate }}
                            </th>
                            <td mat-cell *matCellDef="let item"> {{ item.location }} </td>
                          </ng-container>
                          <!-- volume Column -->
                          <ng-container matColumnDef="volume">
                            <th mat-header-cell *matHeaderCellDef>
                              {{ 'executionEdit.dialog.essay.valuesParticles.cols.volume' | translate }}
                            </th>
                            <td mat-cell *matCellDef="let item"> {{ item.volume + ' ' + item.unit }} </td>
                          </ng-container>
                          <!-- zeroOne Column -->
                          <ng-container matColumnDef="zeroOne">
                            <th mat-header-cell *matHeaderCellDef>
                              {{ 'executionEdit.dialog.essay.valuesParticles.cols.zeroOne' | translate }}
                            </th>
                            <td mat-cell *matCellDef="let item">
                              {{ showParticleNum(item.zeroOne) }}
                            </td>
                          </ng-container>
                          <!-- zeroTwo Column -->
                          <ng-container matColumnDef="zeroTwo">
                            <th mat-header-cell *matHeaderCellDef>
                              {{ 'executionEdit.dialog.essay.valuesParticles.cols.zeroTwo' | translate }}
                            </th>
                            <td mat-cell *matCellDef="let item">
                              {{ showParticleNum(item.zeroTwo) }}
                            </td>
                          </ng-container>
                          <!-- zeroThree Column -->
                          <ng-container matColumnDef="zeroThree">
                            <th mat-header-cell *matHeaderCellDef>
                              {{ 'executionEdit.dialog.essay.valuesParticles.cols.zeroThree' | translate }}
                            </th>
                            <td mat-cell *matCellDef="let item">
                              {{ showParticleNum(item.zeroThree) }}
                            </td>
                          </ng-container>
                          <!-- zeroFive Column -->
                          <ng-container matColumnDef="zeroFive">
                            <th mat-header-cell *matHeaderCellDef>
                              {{ 'executionEdit.dialog.essay.valuesParticles.cols.zeroFive' | translate }}
                            </th>
                            <td mat-cell *matCellDef="let item">
                              {{ showParticleNum(item.zeroFive) }}
                            </td>
                          </ng-container>
                          <!-- oneZero Column -->
                          <ng-container matColumnDef="oneZero">
                            <th mat-header-cell *matHeaderCellDef>
                              {{ 'executionEdit.dialog.essay.valuesParticles.cols.oneZero' | translate }}
                            </th>
                            <td mat-cell *matCellDef="let item">
                              {{ showParticleNum(item.oneZero) }}
                            </td>
                          </ng-container>
                          <!-- fiveZero Column -->
                          <ng-container matColumnDef="fiveZero">
                            <th mat-header-cell *matHeaderCellDef>
                              {{ 'executionEdit.dialog.essay.valuesParticles.cols.fiveZero' | translate }}
                            </th>
                            <td mat-cell *matCellDef="let item">
                              {{ showParticleNum(item.fiveZero) }}
                            </td>
                          </ng-container>
                          <tr mat-header-row *matHeaderRowDef="displayedColumnsParticleCount"></tr>
                          <tr mat-row *matRowDef="let row; columns: displayedColumnsParticleCount;"></tr>
                        </table>
                        @if (data.compressedGas != null && data.essay?.valuesZeroParticles.length > 0) {
                          <div>
                            <br />
                            <strong>{{ 'common.average' | translate }}</strong>
                            @for (size of getParticleSize(criteria); track size) {
                              <div
                                [class]="getClassParticleNum(criteria, size, getValueAverageParticleCountCompressedGas(size))">
                                {{ size }}: {{ getValueAverageParticleCountCompressedGas(size) }}
                              </div>
                            }
                          </div>
                        }
                    </div>
                    }
                  </div>
              } 
              <div fxFlex="100" fxLayout="column">
                  <div fxLayout="row" class="flexwrap">
                    <div fxFlex="100" fxLayout="row" class="flexwrap">
                      <mat-toolbar color="secondary">
                        {{ 'executionEdit.dialog.essays.particleCount.label' | translate }}
                      </mat-toolbar>
                    </div>
                  </div>
              
                  <div fxFlex="100">
                    <button mat-icon-button color="accent" (click)="josetizeParticles()"
                      matTooltip="{{ 'button.read-josetizer' | translate }}" [disabled]="!enableEditCriteria()">
                      <mat-icon>published_with_changes</mat-icon>
                    </button>
                    <button mat-icon-button color="accent" (click)="uploadExcelParticleCountInput.click()"
                      matTooltip="{{ 'button.upload-excel' | translate }}" [disabled]="!enableEditCriteria()">
                      <mat-icon>cloud_upload</mat-icon>
                    </button>
                    <input accept=".xlsx, .xls, .csv" hidden type="file" (change)="uploadExcelParticleCount($event)"
                      #uploadExcelParticleCountInput>
                    @if (data.essay?.idExcel != null) {
                      <button mat-icon-button color="accent" (click)="downloadExcelParticleCount()"
                        matTooltip="{{ 'button.download-excel' | translate }}">
                        <mat-icon>cloud_download</mat-icon>
                      </button>
                    }
                    <button mat-icon-button color="accent" (click)="downloadJosetizer()"
                      matTooltip="{{ 'button.download-josetizer' | translate }}" [disabled]="!enableEditCriteria()">
                      <mat-icon>add_task</mat-icon>
                    </button>
                    <table #valuesParticles mat-table matSort [dataSource]="data.essay.valuesParticles">
                      <!-- date Column -->
                      <ng-container matColumnDef="date">
                        <th mat-header-cell *matHeaderCellDef>
                          {{ 'executionEdit.dialog.essay.valuesParticles.cols.date' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let item"> {{ item.date | fixDateTime }} </td>
                      </ng-container>
                      <!-- location Column -->
                      <ng-container matColumnDef="location">
                        <th mat-header-cell *matHeaderCellDef>
                          {{ 'executionEdit.dialog.essay.valuesParticles.cols.location' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let item"> {{ item.location }} </td>
                      </ng-container>
                      <!-- volume Column -->
                      <ng-container matColumnDef="volume">
                        <th mat-header-cell *matHeaderCellDef>
                          {{ 'executionEdit.dialog.essay.valuesParticles.cols.volume' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let item"> {{ item.volume + ' ' + item.unit }} </td>
                      </ng-container>
                      <!-- zeroOne Column -->
                      <ng-container matColumnDef="zeroOne">
                        <th mat-header-cell *matHeaderCellDef>
                          {{ 'executionEdit.dialog.essay.valuesParticles.cols.zeroOne' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let item"
                          [class]="getClassParticleNum(criteria, '0.1', item.zeroOne)">
                          {{ showParticleNum(item.zeroOne) }}
                        </td>
                      </ng-container>
                      <!-- zeroTwo Column -->
                      <ng-container matColumnDef="zeroTwo">
                        <th mat-header-cell *matHeaderCellDef>
                          {{ 'executionEdit.dialog.essay.valuesParticles.cols.zeroTwo' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let item"
                          [class]="getClassParticleNum(criteria, '0.2', item.zeroTwo)">
                          {{ showParticleNum(item.zeroTwo) }}
                        </td>
                      </ng-container>
                      <!-- zeroThree Column -->
                      <ng-container matColumnDef="zeroThree">
                        <th mat-header-cell *matHeaderCellDef>
                          {{ 'executionEdit.dialog.essay.valuesParticles.cols.zeroThree' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let item"
                          [class]="getClassParticleNum(criteria, '0.3', item.zeroThree)">
                          {{ showParticleNum(item.zeroThree) }}
                        </td>
                      </ng-container>
                      <!-- zeroFive Column -->
                      <ng-container matColumnDef="zeroFive">
                        <th mat-header-cell *matHeaderCellDef>
                          {{ 'executionEdit.dialog.essay.valuesParticles.cols.zeroFive' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let item"
                          [class]="getClassParticleNum(criteria, '0.5', item.zeroFive)">
                          {{ showParticleNum(item.zeroFive) }}
                        </td>
                      </ng-container>
                      <!-- oneZero Column -->
                      <ng-container matColumnDef="oneZero">
                        <th mat-header-cell *matHeaderCellDef>
                          {{ 'executionEdit.dialog.essay.valuesParticles.cols.oneZero' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let item"
                          [class]="getClassParticleNum(criteria, '1.0', item.oneZero)">
                          {{ showParticleNum(item.oneZero) }}
                        </td>
                      </ng-container>
                      <!-- fiveZero Column -->
                      <ng-container matColumnDef="fiveZero">
                        <th mat-header-cell *matHeaderCellDef>
                          {{ 'executionEdit.dialog.essay.valuesParticles.cols.fiveZero' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let item"
                          [class]="getClassParticleNum(criteria, '5.0', item.fiveZero)">
                          {{ showParticleNum(item.fiveZero) }}
                        </td>
                      </ng-container>
                      <tr mat-header-row *matHeaderRowDef="displayedColumnsParticleCount"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumnsParticleCount;"></tr>
                    </table>
                    @if (data.compressedGas != null && data.essay?.valuesParticles.length > 0) {
                      <div>
                        <br />
                        <strong>{{ 'common.average' | translate }}</strong>
                        @for (size of getParticleSize(criteria); track size) {
                          <div
                            [class]="getClassParticleNum(criteria, size, getValueAverageParticleCountCompressedGas(size))">
                            {{ size }}: {{ getValueAverageParticleCountCompressedGas(size) }}
                          </div>
                        }
                      </div>
                    }
                  </div>
              </div>
            }
            <!-- renFlowAndRate -->
            @if (renFlowAndRate) {
              <div fxFlex>
                <div fxLayout="row">
                  <div fxFlex="10"></div>
                  <div fxFlex="20">
                    <div fxLayout="row">
                      <mat-form-field class="campoFormulario">
                        <mat-label>{{'executionEdit.dialog.essay.data.total.flow' | translate}}</mat-label>
                        <input matInput disabled [value]="showTotalFlow(criteria)" type="number">
                      </mat-form-field>
                    </div>
                  </div>
                  <div fxFlex="20">
                    <div fxLayout="row">
                      <mat-form-field class="campoFormulario">
                        <mat-label>{{'executionEdit.dialog.essay.data.changes' | translate}}</mat-label>
                        <input matInput disabled [value]="showRenH(criteria)" type="number">
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                @for (location of getValuesOfCriteria(criteria); track location; let indexLocation = $index) {
                  <div fxLayout="row"
                    >
                    <div fxFlex="20" style="margin-top: 0.5em;">
                      {{ getIndexFilter(location.uuidFilter) + 1 }}.
                      {{ showFilterName(location.uuidFilter) | translate }} {{showFilterIdentifier(location.uuidFilter)}}
                      {{ getSizeFilter(location.uuidFilter) }}
                      <button mat-icon-button (click)="editFilterByUUID(location.uuidFilter)"
                        matTooltip="{{ 'button.edit' | translate }}">
                        <mat-icon>mode_edit</mat-icon>
                      </button>
                    </div>
                    <div fxFlex="8em">
                      <mat-checkbox (change)="justCaudal($event, location)" [checked]="checkJustCaudal(location)"
                        style="padding-top: 1em;"
                        [disabled]="!enableEditEssay() || disabledJustCaudal(location)">
                        Solo caudal
                      </mat-checkbox>
                    </div>
                    @if (!checkJustCaudal(location)) {
                      <div fxFlex="6em" style="margin-top: 0.75em;">
                        <span style="padding-top: 1em;display: block;">
                          {{ 'executionEdit.essaySpeed.speeds' | translate }}:
                        </span>
                      </div>
                    }
                    @for (valueInput of location.data; track trackByIndex(indexValueInput, valueInput); let indexValueInput = $index) {
                      <div fxFlex="8em"
                        >
                        @if (!checkJustCaudal(location)) {
                          <mat-form-field class="campoFormulario">
                            <input matInput type="number" class="noArrow" required [value]="valueInput.value"
                              (blur)="setData(location, indexValueInput, $event.target.value)"
                              name="valueInputValue{{indexCriteria}}{{indexLocation}}{{indexValueInput}}"
                              [disabled]="!enableEditEssay()">
                            <mat-error>
                              {{ 'executionEdit.dialog.essay.data.field.error' | translate }}
                            </mat-error>
                            @if (enableEditEssay()) {
                              <button matSuffix mat-icon-button class="btn-close-location"
                                (click)="deleteDataLocation(indexCriteria, indexLocation, indexValueInput)">
                                <mat-icon>close</mat-icon>
                              </button>
                            }
                          </mat-form-field>
                        }
                      </div>
                    }
                    @if (!checkJustCaudal(location)) {
                      <div fxFlex="2em">
                        <button mat-icon-button color="accent" (click)="addDataValue(indexCriteria, indexLocation)"
                          [disabled]="!enableEditEssay()">
                          <mat-icon class="icon-display-plus">add</mat-icon>
                        </button>
                      </div>
                    }
                    @if (!checkJustCaudal(location)) {
                      <div fxFlex="6em">
                        <mat-form-field class="campoFormulario">
                          <mat-label>{{ 'protocolEdit.dialog.essay.criteria.averageSpeed.label' | translate }}</mat-label>
                          <input matInput disabled [value]="showAverageSpeed(location)">
                        </mat-form-field>
                      </div>
                    }
                    @if (checkJustCaudal(location)) {
                      <div fxFlex="6em">
                        <mat-form-field class="campoFormulario">
                          <mat-label>{{'executionEdit.dialog.essay.data.flow' | translate}}</mat-label>
                          <input matInput [(ngModel)]="location.value"
                            [errorStateMatcher]="matcher" type="number" [disabled]="!enableEditEssay()"
                            [ngModelOptions]="{standalone: true}">
                        </mat-form-field>
                      </div>
                    }
                    @if (!checkJustCaudal(location)) {
                      <div fxFlex="6em">
                        <mat-form-field class="campoFormulario">
                          <mat-label>{{'executionEdit.dialog.essay.data.flow' | translate}}</mat-label>
                          <input matInput disabled [value]="showFlow(location)"
                            type="number">
                        </mat-form-field>
                      </div>
                    }
                    <div fxFlex="4">
                      @if (showDeleteValue(criteria)) {
                        <button mat-icon-button color="accent" (click)="deleteValue(indexCriteria, indexLocation)"
                          [disabled]="!enableEditEssay()">
                          <mat-icon class="icon-display">delete</mat-icon>
                        </button>
                      }
                    </div>
                  </div>
                }
              </div>
            }
            <!-- Air Speed -->
            @if (showSpeed) {
              <div fxFlex>
                <div fxLayout="row">
                  <div fxFlex="20">
                    @if (showIsChanneled) {
                      <mat-checkbox [value]="isChanneled" [checked]="isChanneled" [disabled]="data.disabled"
                        (change)="changeChanneled($event, criteria)">
                        {{'executionEdit.channeled.label' | translate }}
                      </mat-checkbox>
                    }
                  </div>
                </div>
                @for (location of getValuesOfCriteria(criteria); track location; let indexLocation = $index) {
                  <div fxLayout="row"
                    >
                    @if (location.uuidFilter != null) {
                      <div fxFlex="15" style="margin-top: 1.5em;">
                        {{getIndexFilter(location.uuidFilter)+1}}. {{ showFilterName(location.uuidFilter) |
                        translate }} {{showFilterIdentifier(location.uuidFilter)}}
                        {{getSizeFilter(location.uuidFilter)}}
                        <button mat-icon-button (click)="editFilterByUUID(location.uuidFilter)"
                          matTooltip="{{ 'button.edit' | translate }}">
                          <mat-icon>mode_edit</mat-icon>
                        </button>
                      </div>
                    }
                    @if (!checkJustCaudal(location)) {
                      <div fxFlex="10">
                        {{ showSpeedType() | translate }}
                      </div>
                    }
                    @for (valueInput of location.data; track trackByIndex(indexValueInput, valueInput); let indexValueInput = $index) {
                      <div fxFlex="9em"
                        >
                        @if (!checkJustCaudal(location)) {
                          <mat-form-field class="campoFormulario">
                            <input matInput type="number" required class="noArrow" [value]="valueInput.value"
                              (blur)="setData(location, indexValueInput, $event.target.value)"
                              name="valueInputValue{{indexCriteria}}{{indexLocation}}{{indexValueInput}}"
                              [disabled]="!enableEditEssay()">
                            <mat-error>
                              {{ 'executionEdit.dialog.essay.data.field.error' | translate }}
                            </mat-error>
                            @if (enableEditEssay()) {
                              <button matSuffix mat-icon-button class="btn-close-location"
                                (click)="deleteDataLocation(indexCriteria, indexLocation, indexValueInput)">
                                <mat-icon>close</mat-icon>
                              </button>
                            }
                          </mat-form-field>
                        }
                      </div>
                    }
                    @if (!checkJustCaudal(location)) {
                      <div fxFlex="4">
                        <button mat-icon-button color="accent" (click)="addDataValue(indexCriteria, indexLocation)"
                          [disabled]="!enableEditEssay()">
                          <mat-icon class="icon-display-plus">add</mat-icon>
                        </button>
                      </div>
                    }
                    @if (!checkJustCaudal(location)) {
                      <div fxFlex="6em">
                        <mat-form-field class="campoFormulario">
                          <mat-label>{{ 'protocolEdit.dialog.essay.criteria.averageSpeed.label' | translate }}</mat-label>
                          <input matInput disabled [value]="showAverageSpeed(location)">
                        </mat-form-field>
                      </div>
                    }
                    @if (location.uuidFilter != null) {
                      <div fxFlex="6em">
                        @if (location.showLocations && showFrontSpeedByFilter(location.uuidFilter)) {
                          <div>
                            <mat-form-field class="campoFormulario">
                              <mat-label>{{ 'protocolEdit.dialog.essay.criteria.frontalSpeed.label' | translate }}</mat-label>
                              <input matInput disabled [value]="showFrontSpeed(location)">
                            </mat-form-field>
                          </div>
                        }
                      </div>
                    }
                    @if (checkJustCaudal(location)) {
                      <div fxFlex="6">
                        {{ 'variable.notApplicable' | translate }}
                      </div>
                    }
                    <div fxFlex="4">
                      @if (showDeleteValue(criteria) && location.showLocations) {
                        <button mat-icon-button color="accent" (click)="deleteValue(indexCriteria, indexLocation)"
                          [disabled]="!enableEditEssay()">
                          <mat-icon class="icon-display">delete</mat-icon>
                        </button>
                      }
                    </div>
                  </div>
                }
              </div>
            }
            <!-- Dew Point -->
            @if (showDewPoint) {
              <div fxLayout="column" style="width: 100%;">
                @for (value of getValuesOfCriteria(criteria); track value; let indexValue = $index) {
                  <div fxFlex fxLayout="row" style="width: 100%;"
                    >
                    <div fxFlex fxLayout="row" style="width: 100%;">
                      <div fxFlex="20" fxFlex.lt-md="100%">
                        <mat-form-field>
                          <input matInput [(ngModel)]="value.value" type="number"
                            name="dewPoint{{indexCriteria}}{{indexValue}}"
                            [ngModelOptions]="{standalone: true}" [disabled]="!enableEditEssay()">
                        </mat-form-field>
                      </div>
                      <div fxFlex="20" fxFlex.lt-md="100%">
                        <mat-form-field>
                          <mat-select [(ngModel)]="value.reference" required
                            name="dewPointReference{{indexCriteria}}{{indexValue}}"
                            [disabled]="!enableEditEssay()">
                            @for (item of getDewPointValues(); track item) {
                              <mat-option [value]="item">
                                {{ 'common.' + item | translate }}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                }
                <div fxFlex fxLayout="row" style="width: 100%;">
                  <div fxFlex fxLayout="row" class="flexwrap">
                    <div fxFlex="10" fxFlex.lt-md="100%">
                      <button mat-icon-button (click)="uploadCertificateDewPointInput.click()" color="accent"
                        matTooltip="{{ 'button.upload-certificate' | translate }}"
                        [disabled]="!enableEditEssay()">
                        <mat-icon>cloud_upload</mat-icon>
                      </button>
                      <input accept="application/pdf" hidden type="file" (change)="uploadCertificate($event)"
                        #uploadCertificateDewPointInput>
                      @if (data.essay.idCertificate != null) {
                        <button mat-icon-button color="accent" (click)="downloadCertificate()"
                          matTooltip="{{ 'button.download' | translate }}">
                          <mat-icon>cloud_download</mat-icon>
                        </button>
                      }
                    </div>
                  </div>
                </div>
              </div>
            }
            <br />
          </div>
        }
        <!-- Ensayo de recuperación -->
        @if (showRecoveryEssay) {
          <div fxFlex>
            <div fxLayout="row" fxFlex="100%">
              <span style="font-weight: bold; padding-top: 2em;" fxFlex="100%"
              [innerHtml]="getValuesEssayRecovery() | safe: 'html'"> </span>
            </div>
          </div>
        }
      </div>
    }

    <br />

    <!-- Fields -->
    @if (data.essay.active) {
      <mat-toolbar color="secondary">
        {{ 'protocolEdit.dialog.essay.fieldsTitle' | translate }}
      </mat-toolbar>
    }
    @if (data.essay.idEssayType != null && data.essay.active) {
      <div>
        <div fxLayout="row" class="flexwrap">
          @for (field of data.essay.essayValues; track field; let indexField = $index) {
            <div fxFlex="50" fxFlex.lt-md="100%"
              >
              <!-- STRING -->
              @if (field.idTypeField == 1) {
                <div>
                  <mat-form-field class="campoFormulario" style="width: 90%">
                    <mat-label>{{ 'protocolEdit.dialog.essay.' + field.translationField + '.label' | translate }}</mat-label>
                    <input matInput disabled [name]="field.translationField" [ngModel]="field.value"
                      [required]="field.required">
                    <mat-error>
                      {{ 'protocolEdit.dialog.essay.' + field.translationField + '.error' | translate }}
                    </mat-error>
                  </mat-form-field>
                  @if (enableEditField(field)) {
                    <button mat-icon-button (click)="openEditField(indexField)">
                      <mat-icon>edit</mat-icon>
                    </button>
                  }
                </div>
              }
              <!-- NUMÉRICO -->
              @if (field.idTypeField == 2) {
                <div>
                  <mat-form-field class="campoFormulario" style="width: 90%">
                    <mat-label>{{ 'protocolEdit.dialog.essay.' + field.translationField + '.label' | translate }}</mat-label>
                    <input matInput disabled [name]="field.translationField" [ngModel]="field.value"
                      type="number" [required]="field.required">
                    <mat-error>
                      {{ 'protocolEdit.dialog.essay.' + field.translationField + '.error' | translate }}
                    </mat-error>
                  </mat-form-field>
                  @if (enableEditField(field)) {
                    <button mat-icon-button (click)="openEditField(indexField)">
                      <mat-icon>edit</mat-icon>
                    </button>
                  }
                </div>
              }
              <!-- TOLERANCIA -->
              @if (field.idTypeField == 3) {
                <div>
                  <div fxFlex="30%" fxFlex.lt-md="100%">
                    <mat-form-field class="campoFormulario">
                      <mat-label>{{ 'protocolEdit.dialog.essay.' + field.translationField + '.label' | translate }}</mat-label>
                      <input matInput disabled [name]="field.translationField" [(ngModel)]="field.value[0]"
                        type="number" [required]="field.required">
                      <mat-error>
                        {{ 'protocolEdit.dialog.essay.' + field.translationField + '.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div fxFlex="30%" fxFlex.lt-md="100%">
                    ±
                    <mat-form-field class="campoFormulario">
                      <mat-label>{{ 'protocolEdit.dialog.essay.valueTolerance.label' | translate }}</mat-label>
                      <input matInput disabled [name]="field.translationField + 'Tolerance'"
                        [(ngModel)]="field.value[1]" type="number" [required]="field.required">
                      <mat-error>
                        {{ 'protocolEdit.dialog.essay.valueTolerance.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  @if (enableEditField(field)) {
                    <button mat-icon-button (click)="openEditField(indexField)">
                      <mat-icon>edit</mat-icon>
                    </button>
                  }
                </div>
              }
              <!-- DIA HORA MIN -->
              @if (field.idTypeField == 4) {
                <div>
                  <div fxLayout="row">
                    <div fxFlex="30%" fxFlex.lt-md="100%">
                      <mat-form-field class="campoFormulario">
                        <mat-label>{{ 'protocolEdit.dialog.essay.' + field.translationField + '.label' | translate }}: {{ 'common.days.label' | translate }}</mat-label>
                        <input matInput [name]="field.translationField + 'Day'" [(ngModel)]="field.value[0]"
                          disabled type="number" [required]="field.required" min="0">
                      </mat-form-field>
                    </div>
                    <div fxFlex="30%" fxFlex.lt-md="100%">
                      <mat-form-field class="campoFormulario">
                        <mat-label>{{ 'common.hours.label' | translate }}</mat-label>
                        <input matInput [name]="field.translationField + 'Hour'"
                          [(ngModel)]="field.value[1]" type="number" disabled [required]="field.required"
                          min="0">
                      </mat-form-field>
                    </div>
                    <div fxFlex="30%" fxFlex.lt-md="100%">
                      <mat-form-field class="campoFormulario">
                        <mat-label>{{ 'common.minutes.label' | translate }}</mat-label>
                        <input matInput [name]="field.translationField + 'Minute'"
                          [(ngModel)]="field.value[2]" type="number" disabled [required]="field.required"
                          min="0">
                      </mat-form-field>
                    </div>
                    @if (enableEditField(field)) {
                      <button mat-icon-button (click)="openEditField(indexField)">
                        <mat-icon>edit</mat-icon>
                      </button>
                    }
                  </div>
                </div>
              }
              <!-- SELECT_ONE -->
              @if (field.idTypeField == 6) {
                <div>
                  <span>
                    {{ 'protocolEdit.dialog.essay.' + field.translationField + '.label' | translate }}
                  </span>
                  <br />
                  <mat-radio-group class="vertical-radio-group" [required]="field.required">
                    @for (doma of field.fieldDomain; track doma) {
                      <mat-radio-button class="vertical-radio-button"
                        [value]="doma.value" disabled [checked]="field.value == doma.value">
                        {{ 'protocolEdit.dialog.essay.' + doma.translation + '.label' | translate }}
                      </mat-radio-button>
                    }
                  </mat-radio-group>
                  @if (enableEditField(field)) {
                    <button mat-icon-button (click)="openEditField(indexField)">
                      <mat-icon>edit</mat-icon>
                    </button>
                  }
                </div>
              }
              <!-- SELECT_MULTI -->
              @if (field.idTypeField == 7) {
                <div>
                  <span>
                    {{ 'protocolEdit.dialog.essay.' + field.translationField + '.label' | translate }}
                  </span>
                  @if (enableEditField(field)) {
                    <button mat-icon-button (click)="openEditField(indexField)">
                      <mat-icon>edit</mat-icon>
                    </button>
                  }
                  <mat-selection-list disabled>
                    @for (doma of field.fieldDomain; track doma) {
                      <mat-list-option checkboxPosition="before" disabled
                        [value]="doma.value" [selected]="isSelectedMulti(field.value, doma.value)">
                        {{ 'protocolEdit.dialog.essay.' + doma.translation + '.label' | translate }}
                      </mat-list-option>
                    }
                  </mat-selection-list>
                </div>
              }
              <!-- BOOLEAN -->
              @if (field.idTypeField == 8) {
                <div>
                  <mat-checkbox [value]="field.value" [checked]="field.value == 'true'" disabled>
                    {{ 'protocolEdit.dialog.essay.' + field.translationField + '.label' | translate }}
                  </mat-checkbox>
                  @if (enableEditField(field)) {
                    <button mat-icon-button (click)="openEditField(indexField)">
                      <mat-icon>edit</mat-icon>
                    </button>
                  }
                </div>
              }
            </div>
          }
          @if (data.essay?.essayValues?.length == 0) {
            <div fxFlex="50" fxFlex.lt-md="100%"
              style="margin-top: 2em;margin-bottom: 2em;">
              {{ 'protocolEdit.dialog.essay.fields.empty' | translate }}
            </div>
          }
        </div>
      </div>
    }
    @if (data.essay.active) {
      <div fxLayout="row" class="flexwrap">
        <!-- Titulo equipos y boton + y boton delete -->
        <mat-toolbar color="secondary">
          {{ 'calibrateEquipmentEdit.patterns.dialog.equipment.label' | translate }}
          <button mat-icon-button color="accent" (click)="addEquipment()" [disabled]="!enableEditEssay()">
            <mat-icon class="icon-display-plus">add</mat-icon>
          </button>
          <mat-checkbox (change)="onChangeAppTypeCheck($event)" [checked]="data.essay.equipmentNA"
            [disabled]="!enableEditEssay()">
            {{ 'executionEdit.dialog.essay.equipment.notApplicable' | translate }}
          </mat-checkbox>
        </mat-toolbar>
        @if (data.essay.equipmentNA) {
          <div fxFlex>
            <br />
            <span> {{ 'executionEdit.dialog.essay.equipment.notApplicable' | translate }} </span>
            <br />
            <br />
          </div>
        }
        @if (!data.essay.equipmentNA) {
          <div fxFlex>
            @for (equipment of data.essay.equipments; track equipment; let indexEquipment = $index) {
              <div fxLayout="row">
                <div fxFlex="30">
                  <mat-form-field class="campoFormulario">
                    <mat-label>{{ 'calibrateEquipmentEdit.patterns.dialog.equipment.label' | translate }}</mat-label>
                    <input matInput [ngModel]="equipment.equipmentName" #trigger="matAutocompleteTrigger"
                      [matAutocomplete]="auto" (keyup)="lookupEquipment($event)"
                      [ngModelOptions]="{standalone: true}" required [disabled]="!enableEditEssay()">
                    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayFn"
                      (optionSelected)="onSensorChange($event, indexEquipment)">
                      @for (item of equipmentAutoComplete; track item; let index = $index) {
                        <mat-option
                          [value]="item">
                          {{ item.name}} ({{item.serialNum}})
                        </mat-option>
                      }
                    </mat-autocomplete>
                    <mat-error>
                      {{ 'calibrateEquipmentEdit.patterns.dialog.equipment.error' | translate }}
                    </mat-error>
                  </mat-form-field>
                </div>
                <div fxFlex="10px">
                  @if (showDeleteEquipment()) {
                    <button mat-icon-button color="accent" (click)="deleteEquipment(indexEquipment)"
                      [disabled]="!enableEditEssay()">
                      <mat-icon>delete</mat-icon>
                    </button>
                  }
                </div>
              </div>
            }
          </div>
        }
        <br />
      </div>
    }

    <br />

    <!-- Videos -->
    @if (showUploadVideo()) {
      <mat-toolbar color="secondary">
        {{ 'executionEdit.videos.title' | translate }}
        <button mat-icon-button color="accent" [disabled]="!enableEditEssay()" (click)="attachmentVideoUpload.click()">
          <mat-icon>cloud_upload</mat-icon>
        </button>
        <input hidden type="file" accept="video/*" multiple (change)="uploadVideo($event)" #attachmentVideoUpload>
      </mat-toolbar>
    }
    @if (showUploadVideo()) {
      <div fxLayout="row" style="width: 100%;">
        <table #videos mat-table matSort [dataSource]="data.essay.videos" style="width: 100%;"  cdkDropList [cdkDropListData]="data.essay.videos"
          (cdkDropListDropped)="dropVideo($event)">
          <!-- Date Column -->
          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'executionEdit.attachments.cols.date' |
              translate }}
            </th>
            <td mat-cell *matCellDef="let item"> {{ item.regFc | fixDateTime }} </td>
          </ng-container>
          <!-- name Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>
            {{ 'protocolEdit.attachments.cols.name' | translate }} </th>
            <td mat-cell *matCellDef="let item"> {{ item.name }} </td>
          </ng-container>
          <!-- Button Edit Column -->
          <ng-container matColumnDef="edit">
            <th mat-header-cell *matHeaderCellDef> {{ 'button.edit' | translate }} </th>
            <td mat-cell *matCellDef="let item">
              @if (item.idVideo != null) {
                <button mat-icon-button [disabled]="!enableEditEssay()" (click)="editAttachmentVideo(item)">
                  <mat-icon>mode_edit</mat-icon>
                </button>
              }
            </td>
          </ng-container>
          <!-- Button download Column -->
          <ng-container matColumnDef="download">
            <th mat-header-cell *matHeaderCellDef> {{ 'button.download' | translate }} </th>
            <td mat-cell *matCellDef="let item">
              @if (item.idVideo != null) {
                <button mat-icon-button (click)="downloadVideo(item.id, item.filename, item.idExecution)">
                  <mat-icon>cloud_download</mat-icon>
                </button>
              }
            </td>
          </ng-container>
          <!-- Button upload Column
          <ng-container matColumnDef="uploadVideo">
            <th mat-header-cell *matHeaderCellDef> {{ 'button.upload' | translate }} </th>
            <td mat-cell *matCellDef="let item">
              <button mat-raised-button (click)="uploadVideoInput.click()" color="accent">
                <mat-icon>cloud_upload</mat-icon>
              </button>
              <input accept="video/*" hidden type="file" (change)="uploadVideo($event)" #uploadVideoInput>
            </td>
          </ng-container>-->
          <!-- Button open video Column -->
          <ng-container matColumnDef="openVideo">
            <th mat-header-cell *matHeaderCellDef> {{ 'button.open-video' | translate }} </th>
            <td mat-cell *matCellDef="let item">
              @if (item.idVideo != null) {
                <button mat-icon-button (click)="openVideo(item.id)">
                  <mat-icon>video_library</mat-icon>
                </button>
              }
            </td>
          </ng-container>
          <!-- Button delete Column -->
          <ng-container matColumnDef="delete">
            <th mat-header-cell *matHeaderCellDef> {{ 'button.delete' | translate }} </th>
            <td mat-cell *matCellDef="let item">
              @if (item.idVideo != null) {
                <button mat-icon-button [disabled]="!enableEditEssay()" (click)="removeVideo(item.id)">
                  <mat-icon>delete</mat-icon>
                </button>
              }
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumnsVideos"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumnsVideos;" cdkDragLockAxis="y" cdkDrag [cdkDragData]="row">
            <span *cdkDragPreview>{{ row.name }}</span>
          </tr>
          <div class="placeholder" *cdkDragPlaceholder></div>
        </table>
      </div>
    }
    <br />

    <!-- Audit -->
    <mat-toolbar color="secondary">
      {{ 'executionEdit.audit.title' | translate }}
    </mat-toolbar>
    <div fxLayout="row" style="width: 100%;">
      <div fxFlex>
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'executionEdit.audit.regUser' | translate }}</mat-label>
          <input matInput disabled [value]="data.essay.regUser != null ? data.essay.regUser : ''">
        </mat-form-field>
      </div>
      <div fxFlex>
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'executionEdit.audit.regFc' | translate }}</mat-label>
          <input matInput disabled [value]="data.essay.regFc != null ? (data.essay.regFc | fixDateTime) : ''">
        </mat-form-field>
      </div>
      <div fxFlex>
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'executionEdit.audit.modUser' | translate }}</mat-label>
          <input matInput disabled [value]="data.essay.modUser != null ? data.essay.modUser : ''">
        </mat-form-field>
      </div>
      <div fxFlex>
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'executionEdit.audit.modFc' | translate }}</mat-label>
          <input matInput disabled [value]="data.essay.modFc != null ? (data.essay.modFc | fixDateTime) : ''">
        </mat-form-field>
      </div>
    </div>

    <br />

    <!-- Observations -->
    <mat-toolbar color="secondary">
      {{ 'executionEdit.observations.title' | translate }}
    </mat-toolbar>

    <div fxLayout="row" style="width: 100%;">
      <div fxFlex>
        <mat-form-field class="campoFormulario" style="width: 100%">
          <mat-label>{{ 'protocolEdit.observations.label' | translate }}</mat-label>
          <textarea rows="5" matAutosizeMinRows="5" matInput
            [(ngModel)]="data.essay.notes"name="observations" style="resize: none;">
          </textarea>
        </mat-form-field>
      </div>
    </div>

    @if (!data.execution.idProtocol) {
      @if (data.essay.idEssayType != null && (data.essay.purpose || data.essay.methodology)) {
        <div fxLayout="row" class="flexwrap">
            <mat-toolbar color="secondary">
                {{ 'protocolEdit.essay.dialog.reportConfig.title' | translate }}
            </mat-toolbar>

            <div fxFlex="100" fxLayout="column">

                <div fxFlex="100">
                    <mat-accordion>
                        <mat-expansion-panel class="overflowX essay-dialog-mat-accordion" [expanded]="purposeTab" (opened)="purposeTab = true" (closed)="purposeTab = false">
                          <mat-expansion-panel-header>
                              <mat-panel-title>
                                  <div fxFlex="100">
                                      <div fxFlex="100">
                                        <div fxFlex="90" class="center-text">
                                              <span [class]="purposeTab ? 'bold' : ''">{{'protocolEdit.essay.dialog.reportConfig.purpose.title' | translate}}</span>
                                        </div>
                                          <div fxFlex="10">
                                              <button mat-icon-button (click)="refreshPurposeAll()" [disabled]="!enableEditCriteria()"
                                                  matTooltip="{{ 'button.refresh' | translate }}">
                                                  <mat-icon>refresh</mat-icon>
                                              </button>
                                          </div>
                                      </div>
                                  </div>
                              </mat-panel-title>
                          </mat-expansion-panel-header>
                          <div fxFlex="100" fxLayout="column">
                            <div fxFlex="100">
                                @if (isBilingual()) {
                                  <span>{{'protocolEdit.dialog.essay.language.original' | translate}}</span>
                                  <br />
                                }
                                <quill-editor class="quill-container ql-editor" [(ngModel)]="data.essay.purpose" [name]="'purpose'" [id]="'purpose'" [modules]="quillConfig" style="height: auto; font-weight: normal;"></quill-editor>
                            </div>

                            @if (isBilingual()) {
                              <div fxFlex="100">
                                  <span>{{'protocolEdit.dialog.essay.language.translate' | translate}}</span>
                                  <br />
                                  <quill-editor class="quill-container ql-editor" [(ngModel)]="data.essay.purposeTranslated" [name]="'purposeTranslated'" [id]="'purposeTranslated'" [modules]="quillConfig" style="height: auto; font-weight: normal;"></quill-editor>
                              </div>
                            }
                          </div>
                        </mat-expansion-panel>
                    </mat-accordion>
                </div>

                <div fxFlex="100">
                    <mat-accordion>
                        <mat-expansion-panel class="overflowX essay-dialog-mat-accordion" [expanded]="methologyTab" (opened)="methologyTab = true" (closed)="methologyTab = false">
                          <mat-expansion-panel-header>
                              <mat-panel-title>
                                  <div fxFlex="100">
                                      <div fxFlex="100">
                                          <div fxFlex="90" class="center-text">
                                              <span [class]="methologyTab ? 'bold' : ''">{{'protocolEdit.essay.dialog.reportConfig.methodology.title' | translate}}</span>
                                          </div>
                                          <div fxFlex="10">
                                              <button mat-icon-button (click)="refreshMethodologyAll()" [disabled]="!enableEditCriteria()"
                                                  matTooltip="{{ 'button.refresh' | translate }}">
                                                  <mat-icon>refresh</mat-icon>
                                              </button>
                                          </div>
                                      </div>
                                  </div>
                              </mat-panel-title>
                          </mat-expansion-panel-header>
                          <div fxFlex="100" fxLayout="column">
                            <div fxFlex="100">
                                @if (isBilingual()) {
                                  <span>{{'protocolEdit.dialog.essay.language.original' | translate}}</span>
                                  <br />
                                }
                                <quill-editor class="quill-container ql-editor" [(ngModel)]="data.essay.methodology" [name]="'methodology'" [id]="'methodology'" [modules]="quillConfig" style="height: auto; font-weight: normal;"></quill-editor>
                            </div>
                            @if (isBilingual()) {
                              <div fxFlex="100">
                                  <span>{{'protocolEdit.dialog.essay.language.translate' | translate}}</span>
                                  <br />
                                  <quill-editor class="quill-container ql-editor" [(ngModel)]="data.essay.methodologyTranslated" [name]="'methodologyTranslated'" [id]="'methodologyTranslated'" [modules]="quillConfig" style="height: auto; font-weight: normal;"></quill-editor>
                              </div>
                            }
                          </div>
                        </mat-expansion-panel>
                    </mat-accordion>
                </div>
            </div>
        </div>
      }
    }
  </div>

  <div mat-dialog-actions class="air-theme">
    <div fxFlex></div>
    <button mat-raised-button color="primary" (click)="onOkClick()"
      [disabled]="data.essay.idEssayType == null || !enableEditCriteria()">
      {{ 'button.save' | translate }}
    </button>
    <div fxFlex="1"></div>
    <!-- Contaje de partículas -->
    @if (showParticleCount && data.essay.valuesParticles?.length > 1) {
      <button mat-raised-button color="accent" (click)="downloadCountStrip()"
        >
      {{ 'button.download' | translate }}</button>
    }

      @if (showParticleCount && data.essay.valuesZeroParticles?.length > 1) {
      <button mat-raised-button color="accent" (click)="downloadZeroCountStrip()"
        >
      {{ 'button.download' | translate }}</button>
    }

    @if (!data.isNew && !data.essay.fromProtocol) {
      <button mat-raised-button color="accent" (click)="delete()"
        [disabled]="!enableEditCriteria()">
      {{ 'button.delete' | translate }}</button>
    }

    <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate }}</button>
  </div>
</form>